import React, { useState } from 'react';
import './GetGemdropButton.css';

export const GetGemdropButton = ({ userId }) => {
  const [isPressed, setIsPressed] = useState(false);

  const handleClick = () => {
    const botUrl = userId
      ? `https://t.me/gemdrop_app_bot?start=ref_${userId}`
      : 'https://t.me/gemdrop_app_bot';
    window.open(botUrl, '_blank');
  };

  return (
    <div className="get-gemdrop-container">
      <button
        className={`get-gemdrop-button ${isPressed ? 'pressed' : ''}`}
        onMouseDown={() => setIsPressed(true)}
        onMouseUp={() => setIsPressed(false)}
        onMouseLeave={() => setIsPressed(false)}
        onClick={handleClick}
      >
        GET GEMDROP
      </button>
    </div>
  );
};